export default "__VITE_ASSET__CtNARMsA__"